import { NOTIFY_ERROR } from 'src/vuex/modules/snackbar/types'
import { SPINNER_TYPES } from 'src/vuex/types'
import { getInvoiceTimeline, getInvoices } from '../apiCalls'
import { StorageColumnsOrder } from './storageColumnsOrder'
import * as types from './types'

export default {
  [types.GET_INVOICES]: async ({ getters, commit }) => {
    try {
      commit(types.SET_IS_TABLE_LOADING, true)

      commit(types.SET_SELECTED_ROWS, [])

      const newInvoices = await getInvoices(getters[types.PARAMS_TO_SEND])

      commit(types.SET_INVOICES, newInvoices.results)

      commit(types.SET_TOTAL_ITEMS, newInvoices.pagination.total_items)
    } catch (err) {
      console.error(err)
    } finally {
      commit(types.SET_IS_TABLE_LOADING, false)
    }
  },
  [types.CHANGE_PAGINATION]({ commit }, newPagination) {
    commit(types.SET_PAGINATION, newPagination)
  },
  [types.TOGGLE_CUSTOM_COLUMNS_DIALOG]({ commit }, turn) {
    commit(types.SET_IS_CUSTOM_COLUMNS_DIALOG_OPEN, turn)
  },
  [types.CHANGE_COLUMNS_ORDER_TO_SAVE]({ commit }, newColumnsOrderToSave) {
    commit(types.SET_COLUMNS_ORDER_TO_SAVE, newColumnsOrderToSave)
  },
  [types.CHANGE_COLUMNS_ORDER]({ commit }, newColumnsOrder) {
    commit(types.SET_COLUMNS_ORDER, newColumnsOrder)

    StorageColumnsOrder.set(newColumnsOrder)
  },
  [types.CHANGE_SELECTED_ROWS]({ commit }, newSelectedRows) {
    commit(types.SET_SELECTED_ROWS, newSelectedRows)
  },
  [types.CHANGE_SELECTED_ACTION]({ commit }, newSelectedAction) {
    commit(types.SET_SELECTED_ACTION, newSelectedAction)
  },
  [types.CHANGE_IS_WARNING_ROW_SHOWN]({ commit }, turn) {
    commit(types.SET_IS_WARNING_ROW_SHOWN, turn)
  },
  [types.CHANGE_FILTERS]({ commit }, { key, value }) {
    commit(types.SET_FILTERS, {
      key,
      value
    })
  },
  [types.RESET_PAGINATION]({ state, dispatch }) {
    dispatch(types.CHANGE_PAGINATION, {
      ...state.pagination,
      page: 1
    })
  },
  [types.CHANGE_ACTION_DIALOGS]({ commit }, { invoices, isBulk, key, turn }) {
    commit(types.SET_ACTION_DIALOGS, {
      invoices,
      isBulk,
      key,
      turn
    })
  },
  [types.CLOSE_AND_RESET_ACTION_DIALOGS]({ commit, dispatch }) {
    commit(types.SET_ACTION_DIALOGS)
    dispatch(types.CHANGE_IS_WARNING_ROW_SHOWN, false)
    dispatch(types.CHANGE_SELECTED_ACTION, '')
  },
  [types.CHANGE_IS_TABLE_SELECT_ALL_MODE]({ commit }, turn) {
    commit(types.SET_IS_TABLE_SELECT_ALL_MODE, turn)
  },
  async [types.GET_INVOICE_EVENTS](_, invoiceId) {
    const events = await getInvoiceTimeline(invoiceId)

    // Need to remove the rejected ones from the events since they also come in the comments
    return events.reduce((agg, event) => {
      if (event.data.state !== 'REJECTED') {
        agg.push({
          id: event.id,
          occurredOn: event.occurred_on,
          state: event.data.state,
          tenantName: event.data.tenant_name
        })
      }

      return agg
    }, [])
  },
  [types.GET_INVOICE_COMMENTS]({ state }, { invoiceId, invoiceDetails }) {
    // In the list view we need to find the current invoice
    // In the details view we already know the invoice value
    const currentInvoice =
      invoiceDetails === null
        ? state.invoices.find((invoice) => invoice.id === invoiceId)
        : invoiceDetails

    if (currentInvoice.comments) {
      return currentInvoice.comments.map((comment) => {
        return {
          id: comment.id,
          occurredOn: comment.created_at,
          message: comment.message,
          tenantName: comment.tenant_name,
          state: comment.type
        }
      })
    } else {
      return []
    }
  },
  async [types.CHANGE_TIMELINE](
    { commit, dispatch },
    { invoiceId, invoiceDetails = null }
  ) {
    try {
      dispatch(SPINNER_TYPES.SPINNER.SHOW)

      // Timeline events comes from the getInvoiceTimeline request
      const events = await dispatch(types.GET_INVOICE_EVENTS, invoiceId)

      // Timeline comments comes in the prop 'comments' from the getInvoices request
      const comments = await dispatch(types.GET_INVOICE_COMMENTS, {
        invoiceId,
        invoiceDetails
      })

      commit(types.SET_TIMELINE, {
        isOpen: true,
        invoiceId,
        data: [...comments, ...events]
      })
    } catch (err) {
      console.error(err)
      dispatch(NOTIFY_ERROR, {
        message:
          'An error has ocurred trying to get the timeline. Please, try again'
      })
    } finally {
      dispatch(SPINNER_TYPES.SPINNER.HIDE)
    }
  },
  [types.CLOSE_TIMELINE]({ commit }) {
    commit(types.SET_TIMELINE, {
      isOpen: false,
      invoiceId: '',
      data: []
    })
  }
}
